import { CurrentBrandingQuery, Price } from "graphql.generated";

export function getZoneActivePrice<K extends Pick<Price, 'deletedAt' | 'active'> & { zone?: { id: string } }>(
  prices: K[],
  zoneId: string,
) {

  const existingPrices = prices?.filter((p) => !p.deletedAt); // Filter out deleted prices

  const activePrices = existingPrices?.filter((p) => p.active); // Filter out inactive prices

  if (activePrices?.length === 1) { return activePrices?.[0]; } // If only one active price then return it

  const zonePrice = activePrices?.find((ap) => ap.zone?.id === zoneId); // Find exact zone price if it exists

  if (zonePrice) { return zonePrice; } // If we have an exact zone match then return it

  return activePrices?.[0];
}

export function findPriceInProducts(
  products: CurrentBrandingQuery['products']['products'] ,
  priceId: string,
) {
  for (const product of products || []) {
    for (const price of product.prices || []) {
      if (price.id === priceId) {
        return { product, price };
      }
    }
  }

  return {};
}
